import { useSuspenseQuery } from "@tanstack/react-query";

import { ReactQueryKeysAccount } from "services/queryKeys";

import { SUPPORT_ROLE_NAME } from "./constants";
import { fetchRoleNames } from "./fetchRoleNames";

export const useRbacRoleNames = (): string[] => {
  const queryKey: (string | undefined)[] = [
    ReactQueryKeysAccount.rbacRoleNames,
  ];

  const { data } = useSuspenseQuery<string[], Error>({
    queryKey,
    queryFn: () => fetchRoleNames(),
  });

  return (data || []).filter(roleName => roleName !== SUPPORT_ROLE_NAME);
};
